import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'

const getCampaignData = (cleanQuery) => {
  if (!cleanQuery) return null

  const params = {}
  const pairs = cleanQuery.split('&')

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=')

    if (key && value) {
      params[key] = decodeURIComponent(value)
    }
  })

  return params
}

const Preloader = ({ isFetching, isKCGFetching }) => {
  const [isMounted, setIsMounted] = useState(false)

  const trackSessionByQuery = () => {
    if (typeof window === 'undefined') return

    const [navigation] = performance.getEntriesByType('navigation')
    const isRefresh = navigation && navigation.type === 'reload'

    if (isRefresh) return

    const fullQuery = window.location.search

    if (
      fullQuery &&
      (fullQuery.includes('source') || fullQuery.includes('utm_'))
    ) {
      const cleanQuery = fullQuery.replace(/&amp;/g, '&').slice(1)
      const campaignData = getCampaignData(cleanQuery)
      try {
        sessionStorage.setItem('campaign_data', JSON.stringify(campaignData))
      } catch (error) {
        // eslint-disable-next-line
        console.error('Failed to store campaign  error')
      }
    }

    segmentTrackAction(EVENT.webSessionStart, {})
  }

  useEffect(() => {
    setIsMounted(true)
    trackSessionByQuery()
  }, [])

  if (isMounted && !isKCGFetching && !isFetching) {
    return null
  }

  return (
    <div id="preloader">
      <noscript>
        <div className="pre__noscript">
          We need Javascript to be enabled,
          <br />
          please enable it or upgrade your browser.
          <br />
        </div>
      </noscript>
    </div>
  )
}

Preloader.defaultProps = {
  isFetching: false,
  isKCGFetching: false,
}

Preloader.propTypes = {
  isFetching: PropTypes.bool,
  isKCGFetching: PropTypes.bool,
}

export default Preloader
